import { styled } from '@mui/material/styles';
import { getCustomerBasedProfile } from 'app/main/apps/common/AuraFunctions';
import { Link } from 'react-router-dom';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function Logo() {
  return (
    <Root className="flex items-center">
      <div>
        <Link to="/">
          <img className="w-160 my-24" src={getCustomerBasedProfile.companyLogo} alt="logo" />
        </Link>
      </div>
    </Root>
  );
}

export default Logo;
